import { Component, ElementRef } from '@angular/core';
//jeb import { MDCSnackbar } from '@material/snackbar';
import { AuthenticationService } from './user/authentication.service';

@Component({
    selector: 'matrix-tools-ui',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  // Read "Input()" from bootstrapped matrix-tools-ui element
  public IsMatrixToolsDashboard: boolean;
 

  constructor(private elementRef: ElementRef, private auth: AuthenticationService) {
    this.IsMatrixToolsDashboard = this.elementRef.nativeElement.getAttribute('IsMatrixToolsDashboard');

    this.auth.refreshCurrentUser();

    //jeb //setTimeout(() => this.snackBar.openFromComponent(OfferComponent, { duration: 10000, horizontalPosition: 'center' }), 5000);
    //const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));//jeb gotta redo the html, redo offer component ?
    //snackbar.open();
  }
}
